export const MULTI_TENANT_ENABLED = import.meta.env.VITE_MULTI_TENANT === 'true';
